import React, { useEffect, useState } from "react";
import { useParams } from "react-router";

/* 

f0_: {
      frage: `Das`,
      antworten: [{weiter: "f0_", text: `wie`}],
   },

*/

const zwischenfragen = [
   `Wie sind Sie denn auf den Preis gekommen? Gern erstellen wir Ihnen eine kostenfreie Marktanalyse  die Ihnen auch beim privaten Verkauf helfen kann.`,
   `Wie läuft es denn bisher? `,
   `Warum verkaufen Sie denn so eine Immobilie derzeit?`,
   `Wie könnte ich Sie denn locken unsere Dienste zumindest zu testen?`,
   `Hatten Sie schon viele Intertessenten die anstrengend waren?`,
   `Sicherlich haben schon eine Menge Makler angerufen?`,
   `Helfen Sie mir, mit was könnte ich Sie jetzt überzeugen?`,
   `wie wäre es denn wenn sie beim verkauf an eine kunden von uns mehr geld nach abzug der provision erhalten als beim privatverkauf`,
];
const data = {
   absage: {
      frage: "kein Problem, ich vermerke das wünsche Ihnen alles Gute, gern können Sie sich melden falls es zu Komplikationen kommt.",
      antworten: [],
   },
   termin: { frage: "Terminvereinbarung", antworten: [{ text: "Termin vereinbaren", weiter: false }] },
   unterlagen: {
      frage: `Das ist völlig in Ordnung, ich drücke IHnen die Daumen das der Verkauf für Sie gut klappt. Gern würden wir Ihnen unser kurze Broschüre zusenden.`,
      antworten: [{ weiter: false, text: `Entsprechende Unterlagen versenden und auf Vorlage setzen` }],
   },
   f0: {
      frage: `Hallo Herr/Frau [Nachname], ich hoffe, ich störe Sie nicht. Mein Name ist [Ihr Name] von BAUR Immobilien.
        Ich habe Ihre Anzeige gesehen und wollte nachfragen ob die Wohnung/das Haus noch verfügbar ist?
        Sie könnte gut zu einigen unserer Kunden passen die über uns eine Immobilie suchen?
        Darf ich fragen, ob Sie sich schon Gedanken gemacht haben, ob die Zusammenarbeit mit einem Makler für Sie in Frage käme?`,
      antworten: [
         { text: `Ich will keine Provision bezahlen darum mache ich es selber`, weiter: "f0_0" },
         { text: `Ich möchte keinen Makler`, weiter: "f0_1" },
         { text: `Wir haben bereits viele Interessenten`, weiter: "f0_2" },
         { text: `Wir sind noch ganz am Anfang`, weiter: "f0_3" },
         { text: `Wir wollen privat verkaufen`, weiter: "f0_4" },
         { text: `Sie dürfen mich nicht anrufen?`, weiter: "f0_5" },
         { text: `Haben Sie denn echte Kunden für meine Immobilie?`, weiter: "f0_6" },
         { text: `Wenn Sie wirklich Suchkunden haben, können Sie mit denen kommen`, weiter: "f0_7" },
         { text: `Ich will nicht das meine Käufer Provision bezahlen müssen!`, weiter: "f0_8" },
         { text: `Die Immobilie ist schon verkauft`, weiter: "f0_9" },
         { text: `Wir sprechen bereits mit einem anderen Makler`, weiter: "f0_10" },
         { text: `Wir haben schon einen anderen Makler`, weiter: "f0_11" },
         { text: `Die gleichen Kunden die sie haben sehen doch auch meine Anzeige`, weiter: "f0_12" },
         { text: `Was unterscheidet Sie vonm anderen Maklern`, weiter: "f0_13" },
         { text: `Was würde mir das bringen?`, weiter: "f0_14" },
      ],
   },
   f0_0: {
      frage: `Das kann ich verstehen, ich würde auch keine Provision bezahlen wollen. Aber was wäre wenn Ihnen anch Abzug aller Kosten mindestens der von Ihnen gewünschte Kaufpreis verbleibt oder Sie eventuell sogar mehr übrig hätten als Sie gedacht hätten?`,
      antworten: [{ text: `wie soll das denn gehen?`, weiter: "f0_0_0" }],
   },
   f0_0_0: {
      frage: `Wir haben als Makler schon den Anspruch das Sie als Verkäufer mindestens so gut fahren wie wenn Sie privat verkaufen oder soagr besser. Will heisse wenn wir Ihre Immobilie vermarkten sollten Sie einem Verkauf nur zustimmemn wenn der Kaufpreis der nach Abzug der Provision dem entsprciht zu dem Sie privat verkaufen würden. Sonst hätten Sie ja wenig Merhwert. Sicher interessant, dass Sie unsere Tätigkiet austesetn können, wir arbeiten ohne Vertrag und ohne Bindung Sie können unsere Arbeit testen udn wenn es nicht gefällt direkt wieder stoppen. Was ahlten Sie davon`,
      antworten: [
         { text: `Wenn das so ist, können wir das gern näher besprechen`, weiter: "termin" },
         { text: `Ich will das trotzdem nicht.`, weiter: "unterlagen", ratgeber: "", frist: 14 },
      ],
   },
   f0_1: {
      frage: `Oh das ist schade. Haben Sie schon einmal schlechte Erfahrungen gemacht?`,
      antworten: [{ weiter: "f0_1_0", text: `Makler alle doof! ;-)` }],
   },
   f0_1_0: {
      frage: `Gern würden wir Ihnen zeigen das ein Makler durchaus auch sehr nüzlich sein kann für den Verkauf. Wäre es nicht ein Versuch wert zu schauen was wir für Sie tun können ohne das Sie sich zu etwas verpflichten? Zum einen können Sie weiterhin privat verkaufen zum anderen können Sie unsere Bemühungen direkt stoppen wenn Sie keinen Mehrwert sehen.`,
      antworten: [
         {
            weiter: "unterlagen",
            text: `Nein ich will nicht!`,
            ratgeber: "",
            frist: 14,
            ratgeberText:
               "Das ist völlig in Ordnung, ich drücke IHnen die Daumen das der Verkauf für Sie gut klappt. Gern würden wir Ihnen unser kurze Broschüre zum privaten Immobilienverkauf zusenden.",
         },
         { weiter: "termin", text: `Na gut` },
      ],
   },

   f0_2: {
      frage: `Das freut mich und wundert mich nicht. Woran scheitert es bisher?`,
      antworten: [
         {
            weiter: "f0_2_0",
            text: `Diverse Dinge, die Kunden haben etwas auszusetzten, Finanzierungen klappen nicht usw.`,
         },
         {
            weiter: "f0_2_1",
            text: `Wir sind ganz am Anfang, wir wollen mal schauen was passiert`,
         },
         {
            weiter: "unterlagen",
            text: `So wie es aussieht sind Kunden in der finalen Entscheidung, wir rechnen bald mit einer Zusage.`,
            ratgeber: "",
            ratgeberText: `Das freut mich sehr, ich drücke Ihnen die Daumen. Haben Sie bereits alles Unterlagen zusammengestellt die Sie dem Käufer geben sollten? ich sende Ihnen gern unsere Aufstellung zu. Dort finden Sie alle Unterlagen die Sie dringend vorlgien haben soltlen. Sie wissen das Sie bei der Finanzierung derzeit sehr gut aufpassen müssen, Sie sollten nicht beurkunden bevor Sie die Grundschuldbestellung vorliegen haben. Soll ich Ihnen unseren kurzen Leitfaden zuschicken? Da sind einige wertvolle Hinweise drin.`,
            frist: 14,
         },
         {
            weiter: "f0_2_3",
            text: `Wir haben schon einen Interessenten der kaufen will.`,
         },
      ],
   },
   f0_2_0: {
      frage: `Das kennen wir gut. Das kann ganz schon nervenaufreibend sein. Da könnten wir Ihnen einiges an Stress und Aufregung abnehmen. Wäre es nicht angenehm sich zurückzulehen und andere die Arbeit tun zu lassen?`,
      antworten: [
         { weiter: "f0_2_0_0", text: `Schon....diverse Frage zu Provision und Ablauf` },
         { weiter: "f0_2_0_1", text: `Wir wollen es erst mal noch eine Weile versuchen` },
      ],
   },
   f0_2_0_0: {
      frage: `Das erkläre ich Ihnen alles gern bei einem kurzen Kennenlernen. Wann würde es denn ei Ihnen  passen, das wir uns mal kurz unverbildich treffen?`,
      antworten: [{ weiter: "termin", text: `Terminvereinbarung` }],
   },
   f0_2_0_1: {
      frage: `Das kann ich verstehen, darf ich Ihnen unseren kurzen Ratgeber zusenden auf was zu achten ist beim Immobilienverkauf?`,
      antworten: [{ weiter: "unterlagen", text: `unterlagen`, ratgeber: "", frist: 8 }],
   },
   f0_2_1: {
      frage: `Das kann ich gut verstehn. Wie ist denn bisher der Verlauf?`,
      antworten: [{ weiter: "f0_2_1_0", text: `egal ob der Kunde hier gut oder schlecht sagt....` }],
   },

   f0_2_1_0: {
      frage: `BIs wann möchten Sie denn den Verkauf abgewickelt haben?`,
      antworten: [
         { weiter: "f0_2_1_0_0", text: `eher kurzfristig` },
         { weiter: "unterlagen", text: `keine Eile`, ratgeber: "privater Immobilienverkauf", frist: 14 },
      ],
   },
   f0_2_1_0_0: {
      frage: `Wäre es da nicht wert nochmal drüber nachzudenken zusätlziche Hilfe von uns in Anspruch zu nehmen?`,
      antworten: [
         {
            weiter: "unterlagen",
            text: `nein wie gesagt, wir versuchen es erst selber`,
            ratgeber: "privater Immobilienverkauf",
            frist: 14,
         },
         { weiter: "termin", text: `ja gut, vielleicht doch?` },
      ],
   },

   f0_2_3: {
      frage: `Das freut mich sehr, ich drücke Ihnen die Daumen. Haben Sie bereits alles Unterlagen zusammengestellt die Sie dem Käufer geben sollten? ich sende Ihnen gern unsere Aufstellung zu. Dort finden Sie alle Unterlagen die Sie dringend vorlgien haben soltlen. Sie wissen das Sie bei der Finanzierung derzeit sehr gut aufpassen müssen, Sie sollten nicht beurkunden bevor Sie die Grundschuldbestellung vorliegen haben. Soll ich Ihnen unseren kurzen Leitfaden zuschicken? Da sind einige wertvolle Hinweise drin.`,
      antworten: [
         { weiter: "f0_2_3_0", text: `Brauche ich nicht` },
         { weiter: "f0_2_3_1", text: `Gern senden Sie mir die Unterlagen gern zu.` },
      ],
   },
   f0_2_3_0: {
      frage: `Gibt es schon einen Termin zur Beurkundung?`,
      antworten: [
         {
            weiter: "unterlagen",
            text: `Ja, in x Tagen`,
            ratgeber: "Notarielle Abwicklung",
            frist: false,
            ratgeberText:
               "Das ist sehr gut, ich drücke die Daumen. Finazierung ist gesichert nehme ich an? Darf ich Ihnen unseren Ratgeber zusenden auf was zu achten ist bei der notariellen Abwicklung?",
         },
         { weiter: "f0_2_3_0_0", text: `Nein noch nicht` },
      ],
   } /* ---------------
   
   
   
   
   -----------------*/,
   f0_2_3_0_0: {
      frage: `Gibt es einen Grund für so eine lange Wartezeit. Wir empfehlen eigentlich immer eine rasche Beurkundung wenn der Käufer sich entschieden hat. Oder macht der Käufer den Kaufvertrag noch von irgendwas abhängig? (z.B. Finanzierung oder Begehung mit dem Gutachter)`,
      antworten: [
         {
            weiter: "f0_2_3_0_0_0",
            text: `Diverse Gründe, z.B. noch kein Termin vereinbart, Käufer hat noch keine finale Finanzierung usw.`,
         },
      ],
   },
   f0_2_3_0_0_0: {
      frage: `Dar ich Ihen eine Ratschlag geben? Wenn Ihr Käufer nicht binnen von max 14 Tagen bereit ist zum Notar zu gehen, gleich aus welchen Gründen, ist er nach unserer Interpretation nur ein Interessent. Da Sie ihn keinesfalls binden können ist es fraglich ob ein Interessent nach längere Zeit überhaupt noch kaufen möchte. Haben Sie sich denn eine Deadline gesetzt bis wann Sie beurkunden möchten?`,
      antworten: [
         {
            weiter: "unterlagen",
            text: `Ja bis zum....`,
            ratgeber: "",
            ratgeberText:
               "Das ist gut, darf ich Ihnen unseren kurzen Ratgeber schicken auf was zu achten ist? Dort sind sicher einige wertvolle Infos für Sie dabei? Ratgeber versenden und WV bis Maximal ein paar Tage VOR dem Notartermin",
         },

         {
            weiter: "unterlagen",
            text: `Nein, er braucht noch eine Weile...`,
            ratgeber: "",
            ratgeberText:
               "Wenn ich Ihnen ein Rat geben darf, fragen Sie Ihn nach einem fixen Termin für eine Beurkundung. Wenn Ihnn den nicht nenn kann oder will, sollten Sie Ihre Verkaufsbemühungen nicht stoppen. Darf ich Ihnen unseren kurzen Ratgeber schicken auf was zu achten ist? Dort sind sicher einige wertvolle Infos für Sie dabei?",
            frist: 14,
         },
      ],
   },
   f0_2_3_1: {
      frage: `Gern, für wann haben Sie denn den notariellen Kaufvertrag geplant?`,
      antworten: [
         { weiter: "f0_2_3_1_0", text: `Noch gar nicht?` },
         { weiter: "f0_2_3_1_1", text: `in x Wochen` },
         {
            weiter: "unterlagen",
            text: `Das will ich Ihnen nicht sagen`,
            ratgeber: "",
            frist: 14,
            ratgeberText:
               "Entschuldigen Sie ich wollte nicht indiskret sein. Ich sende Ihnen den Ratgeber einfach mal zu. Gern höre ich von Ihnen wenn wir vielleicht doch was für Sie tun können?",
         },
         {
            weiter: "unterlagen",
            text: `zeitnaher fester Termin`,
            ratgeber: "Finanzierung",
            frist: false,
            ratgeberText:
               "Das ist sehr gut, ich drücke die Daumen. Finazierung ist gesichert nehme ich an? Darf ich Ihnen unseren Ratgeber zusenden auf was zu achten ist bei der notariellen Abwicklung? Vorlage kurz nach Notartermin (1 Tag)",
         },
      ],
   },

   f0_2_3_1_0: {
      frage: `Oh, warum nicht, hängt die endgültige Entscheidung noch von etwas ab (z.B. Finanzierung des Käufers?)`,
      antworten: [
         {
            weiter: "f0_2_3_0_0_0",
            text: `Diverse Gründe, z.B. noch kein Termin vereinbart, Käufer hat noch keine finale Finanzierung usw.`,
         },
      ],
   },
   f0_2_3_1_1: {
      frage: `Gibt es einen Grund für so eine lange Wartezeit. Wir empfehlen eigentlich immer eine rasche Beurkundung wenn der Käufer sich entschieden hat. Oder macht der Käufer den Kaufvertrag noch von irgendwas abhängig? (z.B. Finanzierung oder Begehung mit dem Gutachter)`,
      antworten: [
         {
            weiter: "f0_2_3_0_0_0",
            text: `Diverse Gründe, z.B. noch kein Termin vereinbart, Käufer hat noch keine finale Finanzierung usw.`,
         },
      ],
   },

   f0_3: {
      frage: `Das habe ich gesehen, wie läuft es bisher, gibt es viele Anfragen?`,
      antworten: [
         {
            weiter: "unterlagen",
            text: `So wie es aussieht sind Kunden in der finalen Entscheidung, wir rechnen bald mit einer Zusage.`,
            ratgeber: "",
            ratgeberText: `Das freut mich sehr, ich drücke Ihnen die Daumen. Haben Sie bereits alles Unterlagen zusammengestellt die Sie dem Käufer geben sollten? ich sende Ihnen gern unsere Aufstellung zu. Dort finden Sie alle Unterlagen die Sie dringend vorlgien haben soltlen. Sie wissen das Sie bei der Finanzierung derzeit sehr gut aufpassen müssen, Sie sollten nicht beurkunden bevor Sie die Grundschuldbestellung vorliegen haben. Soll ich Ihnen unseren kurzen Leitfaden zuschicken? Da sind einige wertvolle Hinweise drin.`,
            frist: 14,
         },
         { weiter: "f0_2_3", text: `Wir haben schon einen Interessenten der kaufen will.` },
         { weiter: "f0_3_0", text: `ist noch nicht abzusehen/ist wenig` },
      ],
   },
   f0_3_0: {
      frage: `Ich würde Ihnen gern anbieten mal die Immobilien anzuschauen und auch nochmal eine kurze Wertanalyse zu erstellen, die Sie ggfs auch für Ihren privaten Verkauf verwenden können`,
      antworten: [
         { weiter: "termin", text: `Termin` },
         {
            weiter: "unterlagen",
            ratgeber: "",
            frist: 14,
            ratgeberText:
               "Kein Problem, was ich Ihnen trotzdem ans Herz legen würde, wir haben eine tolle Broschüre für privatre Eigentümer die viele Tipps und vor allem Hinweise enthält wie man Risiken vermeidet, darf ich Ihnen die zuschicken?",
            text: `Nein das möchte ich derzeit nicht`,
         },
      ],
   },
   f0_4: {
      frage: `Das kann ich gut verstehen. Das ist aber geade des Besondere bei BAUR Immobilien. Wir bieten Ihnen unsere volle Unterstützung an und Sie können trotzdem weiterhin privat verkaufen. Bei uns gibt es keine Bindung oder Exclusivität. Sie erweiteren lediglich Ihre Möglichkeiten.`,
      antworten: [{ weiter: "f0_4_0", text: `Das mag sein, aber wir wollen trotzdem privat verlaufen` }],
   },
   f0_4_0: {
      frage: `Wie gesagt, das könnten Sie bei einer Zusammenarbeit immer noch tun, da wir Sie nicht einschränken, sie würden nur Ihre Möglichkeiteen vervielfachen wenn auch unsere Kunden Gelegeheit hätten Ihre Immobilie kennzulernen? Wäre es nicht schade diese Chance nicht zu nutzen?`,
      antworten: [
         { weiter: "termin", text: `na gut` },
         {
            weiter: "f0_",
            text: `Nein`,
            ratgeber: "privater Immobilienverkauf",
            frist: 14,
            ratgeberText:
               "Völlig in Ordnung, in dem Fall drück ich Ihnen die Daumen, sicherlich findet sich jemand für diese Immobilie. Darf ich Ihnen trotzdem unseren kurzen Ratgeber 'Privater Immobilienverkauf' übersenden?",
         },
      ],
   },

   f0_5: {
      frage: `Sie meinen das Gesetz zum unlauteren Wettbewerb? Da haben Sie grundsätzlich völlig recht. Kaltakquiseanrufe sind verboten. Wir rufen allerdings auf Ihr Angebot an, das für viele unserer Kunden die uns mit der Suche nach Immobilien beauftragt haben passen könnte. Selbstverständlich müssen Sie nicht mit uns reden und ich mache gern einen Vermerk das wir Sie nicht kontaktieren sollen. Entchuldigen Sie bitte wenn unser Anruf unerwünscht war.`,
      antworten: [
         { weiter: "absage", text: `Ich  möchte aber nicht kontaktiert werden` },
         { weiter: "f0_6", text: `Haben Sie denn echte Kunden?` },
      ],
   },
   f0_6: {
      frage: `Wir haben in der Region schon einige Immobilien verkauft und bieten auch derzeit einige Immobilien an. Aus den vielen Interessenten haben sich etliche aktuelle Suchaufträge ergeben. Aber wir würden uns ie Immobilie auf jeden Fall gern erst mit Ihnen gemeinsam anschauen bevor wir Sie unseren Kunden anbieten.`,
      antworten: [
         {
            weiter: "f0_6_0",
            text: `Dashab ich mir schon gedacht, Sie haben wohl keine echte Kunden, das sagen alle Makler`,
         },
         { weiter: "termin", text: `Anschauen können Sie die Immobilie mal, aber ich unterschreibe nichts` },
      ],
   },
   f0_6_0: {
      frage: `Ich kann nicht für die Kollegen sprechen, aber wenn Sie mal auf unsere Homepage schauen möchten, da sehen Sie das wir regelmässig in Ihrer Region verkaufen. Die meisten unserer Interessenten hinterlassen bei uns einen Suchwunsch der immer ob er noch aktuell ist. Ihre Immobilie würde auf viele der Suchwünsche passen. Gern würde ich Sie mir anschauen um Sie unverbindlich unseren Kunden anzubieten?`,
      antworten: [
         { weiter: "termin", text: `na gut` },
         { weiter: "f0_8_0_0", text: `Nein, das will ich nicht` },
      ],
   },
   f0_7: {
      frage: `Wir würden uns die Immobilie zuerst gern anschauen, bevor wir Sie unseren Kunden anbieten. Eine Immobilien unseren Kunden anzubeitend ie wir selbst nicht persönlich gesehen haben entspricht nicht unserer Arbeitsweise und wäre nicht sehr seriös.`,
      antworten: [
         {
            weiter: "f0_6_0",
            text: `Dashab ich mir schon gedacht, Sie haben wohl keine echte Kunden, das sagen alle Makler`,
         },
         { weiter: "termin", text: `Anschauen können Sie die Immobilie mal, aber ich unterschreibe nichts` },
      ],
   },
   f0_8: {
      frage: `Das kann ich absolut verstehen. Niemand zahlt gern Provision. Aber es gibt sehr viele Käufer die auf einen Makler setzen und ganz bewusst über den Makler gehen, so wie die vielen 1000 Suchkunden die wir haben. Wäre es nicht schade, wenn Sie diese Chance nicht zusätlzich nutzen würden? Im Übrigen können Sie bei einer Zusammenarbeit mit uns Ihre Immobilie sogar weiterhin privat verkaufen wenn sich noch ein Interessetn aus Ihrer Ausschreibung zum Kuaf entschliessen sollte.`,
      antworten: [
         { weiter: "termin", text: `Ja, Termin` },
         { weiter: "f0_8_0", text: `Das interessiert micht nicht, ich will nicht mit einem Makler arbeiten` },
      ],
   },
   f0_8_0: {
      frage: `Das ist wirkich sehr schade, gibt es etwas das ich tun kann um Sie vielleicht doch von den Vorteilen zu begeistern?`,
      antworten: [{ weiter: "f0_8_0_0", text: `Nein, auf keinen Fall!` }],
   },
   f0_8_0_0: {
      frage: `Gut das werde ich schweren Herzens akzeptieren müssen. Darf ich Ihnen trotzdem per Mail unseren kleinen Ratgeber auf was man achten sollte beim Verkauf zukommen lassen?`,
      antworten: [
         { weiter: "unterlagen", text: `Ja von mir aus`, ratgeber: "", frist: 14 },
         { weiter: "absage", text: `nein` },
      ],
   },
   f0_9: {
      frage: `Das freut mich sehr für Sie. Sind Sie mit dem Verkauf des Verkaufes und dem Preis zufrieden?.... Hat der Notertemin schon stattgefunden?`,
      antworten: [{ weiter: "f0_9_0", text: `ja` }],
   },
   f0_9_0: {
      frage: `Das freut micht sehr für Sie, ich gratuliere. Darf ich Ihnen unseren kurzen Ratgeber zusenden auf was man achten soll zur Abwicklung?`,
      antworten: [
         {
            weiter: "unterlagen",
            text: `ja`,
            ratgeber: "",
            ratgeberText: "Entsprechende Unterlagen versenden und als gescheitert ablegen",
         },
         { weiter: "absage", text: `nein` },
      ],
   },
   f0_10: {
      frage: `Das ist genau richtig. Und Sie sollten nicht nur mit einem Makelr sprechen. Vergleichen Sie uns und entscheiden Sie ganz gelassen welcher Makler zu Ihnen passt`,
      antworten: [
         { weiter: "termin", text: `Gerne, Terminvereinbarung` },
         { weiter: "f0_10_0", text: `nein, das uns reicht erst mal einer?` },
      ],
   },
   f0_10_0: {
      frage: `Das sprciht für Sie, aber ich kann es Ihnen nur anraten und anbieten. Nur im Vergleich werden Sie sich sicher sein können ob Sie den richtigen Makler für Ihre Situation haben. Wann dürfte ich denn mal vorbeikommen?`,
      antworten: [
         { weiter: "termin", text: `Gerne, Terminvereinbarung` },
         {
            weiter: "unterlagen",
            text: `Lassen Sie es, ich will keinen Vergleich`,
            ratgeber: "",
            frist: 14,
            ratgeberText:
               "Das ist sehr schade aber völlig in Ordung. Darf ich Ihnen trotzden unseren Ratgeber 'Privater Immobilienverkauf' mit vielen Tipps und Tricks senden?",
         },
      ],
   },
   f0_11: {
      frage: `Das ist grundsätzlich gut, wie läuft es bisher`,
      antworten: [
         {
            weiter: "unterlagen",
            text: `ganz zufrieden`,
            ratgeber: "",
            ratgeberText: "das freut mich, ich werde das neugierig verfolgen, ich drücke Ihnen die Daumen",
            frist: 28,
         },
         { weiter: "f0_11_0", text: `unzufrieden` },
      ],
   },
   f0_11_0: {
      frage: `Wie lange sind Sie noch gebunden, bzw. kommen Sie aus dem Vertrag heraus?`,
      antworten: [
         { weiter: "termin", text: `Kurzfristig` },
         {
            weiter: "unterlagen",
            text: `Langfristig`,
            ratgeber: "",
            ratgeberText:
               "Achten Sie darauf, dass der vertrag sich nicht automatisch verlängert, auf wann kommen Sie denn raus? Wiedervorlage je nach Dauer, maximal bis 4 Wochen vor ablauf",
         },
      ],
   },
   f0_12: {
      frage: `Das ist natürlich grundsätzlich richtig, aber zum einen können wir über das Portal trotz gleicher technischer Daten allein über die zielgruppenorientierte Ausschreibung durch unsere Marketing eine ganz ander Quantität an Interessenten erreichen. Zudem erreichen wir weiter eine deutlich größere Anzahl an Interessenten durch die Ausschreibung auf allen Portalen. Ein wichtiger Punkt sind die Synergieeffekte die wir aufrgund unserer vielen Besichtigungen haben. D.h. wir können unseren Interessenten die sich z.B: eine andere Whg angeschuat haben Ihre Whg proaktiv anbieten.`,
      antworten: [{ weiter: "f0", text: `Je nach Antwort am Leitfaden anknüpfen` }],
   },
   f0_13: {
      frage: `BAUR Immobilien – Ihre flexible, risikofreie Lösung
30 Jahre Erfahrung: Tausende Immobilien erfolgreich verkauft, jeden Werktag mindestens eine Immobilie.
Komplettes Team: 40 Experten (Marketing, Aufbereitung, Telefonservice, Abwicklung) arbeiten für Sie.
Professionelle Vermarktung: Hochwertige Innen-, Außen- und Luftaufnahmen, Lifestyle-Exposé im Zeitschriftenstil.
Kein vertraglicher Zwang: Keine Exklusivität, keine Laufzeit, Sie können privat weiterverkaufen. Jederzeit kündbar mit einem Anruf – wir tragen alle Kosten bis dahin.
Risikofreie Zusammenarbeit: Wir gehen auf unser Risiko und in Vorleistung, bezahlt werden wir nur bei erfolgreichem Verkauf und wenn der Kaufpreis  der für Sie verbleibt Sie zufriedenstellt.
`,
      antworten: [],
   },
   f0_14: {
      frage: `1. Kurzvorstellung von BAUR Immobilien:
Spezialisiert auf die Vereinfachung und Absicherung des Verkaufsprozesses
Von der rechtssicheren Aufbereitung der Unterlagen über die zielgruppengerichtete Vermarktung bis zur erfolgreichen Abwicklung des Verkaufs
Ein mehr als 40-köpfiges Team aus Experten (Marketing, Aufbereitung, Telefonservice, Abwicklung) arbeitet für Sie
<br/>
2. Unsere Dienstleistungen:
Direkte Ansprache unserer bestehenden Kunden
Zielgruppengerichtete Vermarktung mit hochwertigem Exposé (Innen-, Außen-, und Luftaufnahmen)
Exposé erstellt von unserer Grafikabteilung und professionell gedruckt in unserer hauseigenen Druckerei
Ausschreibung auf relevanten Plattformen – auf unsere Kosten
<br/>
3. Zusatzleistungen hervorheben:
Koordination der Besichtigungen, Verhandlungen in Ihrem Namen
Bonitätsprüfung der Käufer
Kaufvertrag in Absprache, mit Haftungsausschlüssen und Unterstützung bis zur Beurkundung
<br/>
4. Risikofreie Zusammenarbeit:
Keine vertragliche Bindung, keine Laufzeit
Weiterhin Privatverkauf möglich
Wir gehen auf unser Risiko und tragen alle Kosten bis zur erfolgreichen Vermittlung
Wenn Sie die Zusammenarbeit stoppen möchten, geht das täglich per Anruf. Alle bisherigen Kosten tragen wir.
<br/>
5. Marktwertermittlung Ihrer Immobilie und Marktbericht Ihres Quartiers:
Kostenfreie, aktualisierte Marktwertermittlung Ihrer Immobilie
Zusätzlich ein Marktbericht für Ihr Quartier, den Sie ideal als Unterstützung für Ihren Verkauf nutzen können – auch wenn Sie keine Zusammenarbeit wünschen oder diese beenden.
<br/>
6. Erfolgsbasierte Bezahlung:
Nur Bezahlung bei erfolgreichem Verkauf, wenn Sie mit dem Kaufpreis zufrieden sind, der Ihnen nach Abzug aller Kosten verbleibt
Wir tragen alle Kosten bei nicht erfolgreicher Vermittlung
<br/>
7. Abschlussfrage:
„Klingt das nach einer Unterstützung, die für Sie interessant wäre?“
`,
      antworten: [],
   },
};

export default function Leitfaden({ user }) {
   const [stage, setStage] = useState("f0");
   const [prevStage, setPrevStage] = useState();
   const [prevIndex, setPrevIndex] = useState();
   const [details, setDetails] = useState();

   let params = useParams();

   useEffect(() => {
      if (params.stage) {
         setStage(params.stage);
      }
   }, [params]);

   useEffect(() => {
      let y0 = 0;
      let y1 = 0;
      let y2 = 0;
      let y3 = 0;
      let y4 = 0;

      let abc = Object.keys(data).reduce((oldObj, datakey) => {
         const splitkey = datakey.split("_");
         console.log(splitkey);

         let xPosi = 0;
         let yPosi = 0;

         if (splitkey[4]) {
            yPosi = 2050 * y4;
            y4++;
            xPosi = 8000;
         } else if (splitkey[3]) {
            yPosi = 2050 * y3;
            y3++;
            xPosi = 6000;
         } else if (splitkey[2]) {
            yPosi = 2050 * y2;
            y2++;
            xPosi = 4000;
         } else if (splitkey[1]) {
            // yPosi = 2050 * parseInt(splitkey[1]);
            yPosi = 2050 * y1;
            y1++;
            xPosi = 2000;
         } else if (splitkey[0] === "termin") {
            xPosi = 10000;
            yPosi = 0;
         } else if (splitkey[0] === "unterlagen") {
            xPosi = 10000;
            yPosi = 2200;
         } else if (splitkey[0] === "absage") {
            xPosi = 10000;
            yPosi = 4400;
         }

         return {
            ...oldObj,
            [datakey]: { id: datakey, type: "buttonNode", data: data[datakey], position: { x: xPosi, y: yPosi } },
         };
      }, {});

      console.log(abc);
   }, []);

   useEffect(() => {
      let params = new URLSearchParams(document.location.search);
      let newPrevStage = params.get("prev");
      let newPrevIndex = params.get("index");
      //   console.log(newStage);
      // console.log(data[prevStage].antworten);

      if (newPrevStage) setPrevStage(newPrevStage);
      if (newPrevIndex) setPrevIndex(newPrevIndex);
   }, []);

   return (
      <div className="m-3">
         <title>Leitfaden</title>
         <h1>Telefonieleitfaden:</h1>
         <div className="m-5">
            {/* <h2>{data[stage].frage}</h2> */}
            <div className="flex-row" style={{ alignItems: "start" }}>
               <div style={{ width: "100%" }}>
                  {data[prevStage] && data[prevStage].antworten[parseInt(prevIndex)].ratgeberText ? (
                     <div
                        style={{ fontSize: "x-large", fontWeight: "600", marginBottom: "20px" }}
                        dangerouslySetInnerHTML={{
                           __html: data[prevStage].antworten[parseInt(prevIndex)].ratgeberText,
                        }}
                     />
                  ) : (
                     <div
                        style={{ fontSize: "x-large", fontWeight: "600", marginBottom: "20px" }}
                        dangerouslySetInnerHTML={{ __html: data[stage].frage }}
                     />
                  )}

                  {data[stage].antworten.map((antwort, index) => {
                     let linkStyle = {};
                     if (stage === "termin") {
                        linkStyle["backgroundColor"] = "#009";
                     } else if (stage === "unterlagen") {
                        linkStyle["backgroundColor"] = "#900";
                     } else if (stage === "absage") {
                        linkStyle["backgroundColor"] = "#000";
                     }

                     let url =
                        antwort.weiter || data[antwort.weiter]
                           ? new URL(window.location.origin + "/leitfaden/" + antwort.weiter)
                           : null;
                     console.log(details);

                     if (antwort.ratgeberText) {
                        console.log("setting params");

                        url.searchParams.set("prev", stage);

                        url.searchParams.set("index", index);
                     }

                     return (
                        <a
                           className="leitfaden-button"
                           key={antwort.text}
                           style={linkStyle}
                           disabled={!(antwort.weiter || data[antwort.weiter])}
                           //    href={antwort.weiter || data[antwort.weiter] ? "/leitfaden/" + antwort.weiter : null}
                           href={url}
                           onClick={() => {
                              setDetails(antwort);
                           }}
                           /* onClick={() => {
                        const url = new URL(window.location.href);
                        url.searchParams.set("stage", antwort.weiter);
                        window.history.pushState(null, null, url);
                        setStage(antwort.weiter);
                     }} */
                        >
                           {details && details.ratgeberText ? details.ratgeberText : antwort.text}
                        </a>
                     );
                  })}
               </div>
               <div style={{ width: "700px", marginLeft: "10px", padding: "10px", height: "100%" }}>
                  <h4>Zwischenfragen:</h4>
                  {zwischenfragen.map((zwischenfrage, index) => {
                     return (
                        <div
                           key={"zwischenfragen_" + index}
                           className="leitfaden-button"
                           style={{ backgroundColor: "#224" }}
                        >
                           {zwischenfrage}
                        </div>
                     );
                  })}
               </div>
            </div>
         </div>
      </div>
   );
}
